import { render, staticRenderFns } from "./DataTableLog.vue?vue&type=template&id=26f57f2b"
import script from "./DataTableLog.vue?vue&type=script&lang=js"
export * from "./DataTableLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports